import { useParams, usePathname, useSearchParams } from 'next/navigation';

import { Icon } from '@/components/atomic/atoms';
import { WhyChooseHeader } from '@/components/atomic/molecules';
import { staticMediaStoreBaseURL } from '@/config/common';
import { whyChooseHaflaServices } from '@/services/homePage.service';
import {
  GENERIC_HEBA_PAGE_ROUTE,
  getPlanEventWithHebaURL
} from '@/services/planEventWithHeba.service';

const WhyChooseHaflaOrganism = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = useParams();

  const planEventWithHebaURL = getPlanEventWithHebaURL({
    pageRoute: GENERIC_HEBA_PAGE_ROUTE,
    params,
    pathname,
    searchParams
  });

  return (
    <div className='pt-10'>
      <WhyChooseHeader
        {...{
          buttonText: 'Plan your event',
          buttonUrl: planEventWithHebaURL,
          isOpenInSameTab: true,
          title: 'WHY CHOOSE HAFLA'
        }}
      />
      <div className='flex flex-nowrap items-start w-11/12 mx-auto justify-evenly mt-10 mb-20'>
        {whyChooseHaflaServices.map(({ id, name, image }) => (
          <div
            key={id}
            className='flex flex-col items-center justify-start shadow-xl hover:shadow-2xl shadow-red-100 hover:shadow-red-100 rounded-2xl w-52 h-46'
          >
            <Icon
              {...{
                alt: name,
                className: 'img-center h-30 w-30',
                containerClass: 'shadow-none',
                priority: true,
                title: name,
                titleClassName:
                  'text-center font-Montserrat text-base text-slate-600 items-center w-40 font-bold uppercase',
                url: `${staticMediaStoreBaseURL}${image}`
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseHaflaOrganism;
